// API configuration
export const API_URL = process.env.REACT_APP_API_ENDPOINT || 'https://dev-ledgiventa.akfdev.com/api';

// Authentication configuration
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
export const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID;
export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Stripe configuration
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Environment
export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'prod';
